import { clearManagedOrgOverride } from './managedOrgOverride'

export default function performSignOutCleanup() {
  const hasToken = !!localStorage.getItem('token')
  localStorage.removeItem('token')
  localStorage.removeItem('firstLogin')
  clearManagedOrgOverride()
  if (window.sharedWorker) {
    window.sharedWorker.port.postMessage({
      event: 'stop',
    })
  }
  if (hasToken) {
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }
}
